import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=dace1bfe&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dace1bfe')) {
      api.createRecord('dace1bfe', component.options)
    } else {
      api.reload('dace1bfe', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=dace1bfe&", function () {
      api.rerender('dace1bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2q5k2RPyiYcYB/JS/offershelp.vue"
export default component.exports